module.exports = __webpack_public_path__ + "img/phone.bb0fe333.svg";